"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Calendar, Clock, Building, CheckCircleIcon, Languages, Sparkles, Monitor, CheckCircle } from "lucide-react";
import { EnrollNowDialog } from "./enroll-now-dialog";
import { RenderIf } from "./render-if";
import { formatCurrency } from "@/helpers/format-currency";
import clsx from "clsx";
import { BorderBeam } from "../ui/border-beam";
import { Heading } from "../ui/heading";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { getInitials } from "@/helpers/get-initials";
import { Text } from "../ui/text";
import { ParticipantSelector } from "../ui/participant-selector";
import { FillingFast } from "./filling-fast";
import { RegistrationCloseTimer } from "./registration-close-timer";
import { Popover, PopoverContent, PopoverDescription, PopoverHeader, PopoverTitle, PopoverTrigger } from "../ui/popover";
import { cn } from "@/lib/utils";
import { handleScroll } from "@/helpers/scroll-handler";
import Link from "next/link";
import { usePopup } from "@/providers/popup-provider";
type EventCardProps = {
  data: ServiceEvent;
};
export const EventCard = t0 => {
  const $ = _c(212);
  const {
    data
  } = t0;
  const [quantity, setQuantity] = useState(1);
  const {
    openPopup
  } = usePopup();
  const isCampaignOffer = Boolean(data?.isCampaignOfferApplied);
  const isEarlyBirdOfferApplied = data.isEarlyBirdOfferApplied;
  const hasMappedService = data.hasMappedService;
  const hasTrainer = data.eventDetail.trainer !== null;
  let t1;
  if ($[0] !== data.serviceFlags) {
    t1 = data?.serviceFlags?.includes("HIDE_PRICE_ON_WEBSITE") || false;
    $[0] = data.serviceFlags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isHiddenPrice = t1;
  const t2 = data?.eventCloseDate;
  let t3;
  if ($[2] !== t2) {
    t3 = <RegistrationCloseTimer closeDate={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isCampaignOffer || isEarlyBirdOfferApplied;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BorderBeam duration={6} size={400} borderWidth={3} className="via-secondary from-transparent to-transparent" />;
    t6 = <BorderBeam duration={6} delay={3} size={400} borderWidth={3} className="via-primary from-transparent to-transparent" />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4) {
    t7 = <RenderIf condition={t4}>{t5}{t6}</RenderIf>;
    $[6] = t4;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = data.weekLabel === "Weekend" ? "outline" : "default";
  const t9 = data.weekLabel === "Weekend";
  let t10;
  if ($[8] !== t9) {
    t10 = cn({
      "border-primary text-primary": t9
    });
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== data.weekLabel || $[11] !== t10 || $[12] !== t8) {
    t11 = <Badge variant={t8} className={t10}>{data.weekLabel}</Badge>;
    $[10] = data.weekLabel;
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Badge className="bg-green-50 text-green-700 dark:bg-green-950 dark:text-green-300">Earlybird</Badge>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== isEarlyBirdOfferApplied) {
    t13 = <RenderIf condition={isEarlyBirdOfferApplied}>{t12}</RenderIf>;
    $[15] = isEarlyBirdOfferApplied;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Badge className="animate-pulse bg-orange-50 text-orange-700 dark:bg-orange-950 dark:text-orange-300"><Sparkles size={14} />Spacial Batch Offer</Badge>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== isCampaignOffer) {
    t15 = <RenderIf condition={isCampaignOffer}>{t14}</RenderIf>;
    $[18] = isCampaignOffer;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t11 || $[21] !== t13 || $[22] !== t15) {
    t16 = <div className="space-x-1">{t11}{t13}{t15}</div>;
    $[20] = t11;
    $[21] = t13;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Badge className="inline-flex animate-pulse items-center gap-1.5 rounded-full bg-linear-to-r from-orange-500 via-orange-600 to-orange-500 px-4 py-1.5 text-xs font-bold text-white shadow-lg transition-all hover:scale-110 hover:shadow-xl"><Sparkles size={14} />Spacial Batch Offer</Badge>;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== isCampaignOffer) {
    t18 = <RenderIf condition={isCampaignOffer}>{t17}</RenderIf>;
    $[25] = isCampaignOffer;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span />;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  const t20 = data?.serviceName;
  let t21;
  if ($[28] !== t20) {
    t21 = <Heading as="h6" render={t19} className="mb-2 block font-semibold">{t20}</Heading>;
    $[28] = t20;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== hasMappedService || $[31] !== t21) {
    t22 = <RenderIf condition={hasMappedService}>{t21}</RenderIf>;
    $[30] = hasMappedService;
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Calendar className="text-primary mt-0.5 size-5 shrink-0 transition-transform duration-200 group-hover/item:scale-110 dark:text-blue-400" />;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== data.formattedDate) {
    t24 = <div className="text-sm leading-snug font-bold md:text-base">{data.formattedDate}</div>;
    $[34] = data.formattedDate;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== data.numberOfDays || $[37] !== data.numberOfDaysLabel) {
    t25 = <div className="text-muted-foreground mt-0.5 text-xs font-medium">{data.numberOfDays} {data.numberOfDaysLabel}</div>;
    $[36] = data.numberOfDays;
    $[37] = data.numberOfDaysLabel;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t24 || $[40] !== t25) {
    t26 = <div className="group/item flex items-start gap-3">{t23}<div>{t24}{t25}</div></div>;
    $[39] = t24;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Clock className="text-primary mt-0.5 size-5 shrink-0 transition-transform duration-200 group-hover/item:scale-110 dark:text-blue-400" />;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  if ($[43] !== data.eventDetail.endTime || $[44] !== data.eventDetail.startTime) {
    t28 = <div className="text-sm leading-snug font-bold md:text-base">{data.eventDetail.startTime} to {data.eventDetail.endTime}</div>;
    $[43] = data.eventDetail.endTime;
    $[44] = data.eventDetail.startTime;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== data.eventDetail.timeDiffInHours) {
    t29 = <span>({data.eventDetail.timeDiffInHours} Hrs / Day)</span>;
    $[46] = data.eventDetail.timeDiffInHours;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== data.eventDetail.timezone || $[49] !== t29) {
    t30 = <div className="text-muted-foreground mt-0.5 text-xs font-medium">{data.eventDetail.timezone}{" "}{t29}</div>;
    $[48] = data.eventDetail.timezone;
    $[49] = t29;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== t28 || $[52] !== t30) {
    t31 = <div className="group/item flex items-start gap-3">{t27}<div>{t28}{t30}</div></div>;
    $[51] = t28;
    $[52] = t30;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  const t32 = data.eventDetail?.trainer?.image;
  let t33;
  if ($[54] !== t32) {
    t33 = <AvatarImage src={t32} />;
    $[54] = t32;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  const t34 = data.eventDetail?.trainer?.name ?? "";
  let t35;
  if ($[56] !== t34) {
    t35 = getInitials(t34);
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== t35) {
    t36 = <AvatarFallback>{t35}</AvatarFallback>;
    $[58] = t35;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  let t37;
  if ($[60] !== t33 || $[61] !== t36) {
    t37 = <Avatar>{t33}{t36}</Avatar>;
    $[60] = t33;
    $[61] = t36;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  const t38 = data.eventDetail?.trainer?.name;
  let t39;
  if ($[63] !== t38) {
    t39 = <Text>{t38}</Text>;
    $[63] = t38;
    $[64] = t39;
  } else {
    t39 = $[64];
  }
  const t40 = data.eventDetail?.trainer?.experience;
  let t41;
  if ($[65] !== t40) {
    t41 = <Text className="text-muted-foreground line-clamp-1 truncate">{t40}</Text>;
    $[65] = t40;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] !== t39 || $[68] !== t41) {
    t42 = <div>{t39}{t41}</div>;
    $[67] = t39;
    $[68] = t41;
    $[69] = t42;
  } else {
    t42 = $[69];
  }
  let t43;
  if ($[70] !== t37 || $[71] !== t42) {
    t43 = <div className="flex gap-3">{t37}{t42}</div>;
    $[70] = t37;
    $[71] = t42;
    $[72] = t43;
  } else {
    t43 = $[72];
  }
  let t44;
  if ($[73] !== hasTrainer || $[74] !== t43) {
    t44 = <RenderIf condition={hasTrainer}>{t43}</RenderIf>;
    $[73] = hasTrainer;
    $[74] = t43;
    $[75] = t44;
  } else {
    t44 = $[75];
  }
  let t45;
  if ($[76] !== t22 || $[77] !== t26 || $[78] !== t31 || $[79] !== t44) {
    t45 = <div className="space-y-4">{t22}{t26}{t31}{t44}</div>;
    $[76] = t22;
    $[77] = t26;
    $[78] = t31;
    $[79] = t44;
    $[80] = t45;
  } else {
    t45 = $[80];
  }
  let t46;
  if ($[81] !== t16 || $[82] !== t18 || $[83] !== t45) {
    t46 = <div className="dark:border-slate-850 border-border flex flex-col justify-center gap-6 border-b bg-[#EEF2F6] p-6 md:col-span-3 md:border-r md:border-b-0 dark:bg-slate-900/40">{t16}{t18}{t45}</div>;
    $[81] = t16;
    $[82] = t18;
    $[83] = t45;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  let t47;
  let t48;
  if ($[85] !== data.modeOfTraining) {
    t47 = data.modeOfTraining === "online" ? <Monitor className="text-primary size-5 shrink-0 dark:text-blue-400" /> : <Building className="text-primary size-5 shrink-0 dark:text-blue-400" />;
    t48 = <span className="font-semibold dark:text-slate-200">{data.modeOfTraining}</span>;
    $[85] = data.modeOfTraining;
    $[86] = t47;
    $[87] = t48;
  } else {
    t47 = $[86];
    t48 = $[87];
  }
  let t49;
  let t50;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <CheckCircleIcon className="size-5 shrink-0 animate-pulse text-green-700 duration-1000 dark:text-emerald-400" />;
    t50 = <span className="font-semibold text-green-700 dark:text-emerald-400">Guaranteed to run</span>;
    $[88] = t49;
    $[89] = t50;
  } else {
    t49 = $[88];
    t50 = $[89];
  }
  let t51;
  let t52;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <CheckCircle className="size-5 shrink-0 animate-pulse text-green-700 duration-1000 dark:text-emerald-400" />;
    t52 = <span className="font-semibold text-green-700 dark:text-emerald-400">Special Offer Applied + 4 % Processing Fees Waiver</span>;
    $[90] = t51;
    $[91] = t52;
  } else {
    t51 = $[90];
    t52 = $[91];
  }
  let t53;
  if ($[92] !== data.isEarlyBirdOfferApplied) {
    t53 = <RenderIf condition={data.isEarlyBirdOfferApplied}>{t51}{t52}</RenderIf>;
    $[92] = data.isEarlyBirdOfferApplied;
    $[93] = t53;
  } else {
    t53 = $[93];
  }
  let t54;
  let t55;
  let t56;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <Languages className="text-primary size-5 shrink-0 dark:text-blue-400" />;
    t55 = <span className="font-semibold dark:text-slate-200">English</span>;
    t56 = <div />;
    $[94] = t54;
    $[95] = t55;
    $[96] = t56;
  } else {
    t54 = $[94];
    t55 = $[95];
    t56 = $[96];
  }
  let t57;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <span className="text-slate-850 font-bold dark:text-slate-200">Exam:</span>;
    $[97] = t57;
  } else {
    t57 = $[97];
  }
  const t58 = data.withExam ? "Included" : "Not Included";
  let t59;
  if ($[98] !== t58) {
    t59 = <div className="text-slate-650 dark:text-slate-350">{t57}{" "}{t58}</div>;
    $[98] = t58;
    $[99] = t59;
  } else {
    t59 = $[99];
  }
  let t60;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = <div />;
    $[100] = t60;
  } else {
    t60 = $[100];
  }
  let t61;
  if ($[101] !== data.serviceFlags) {
    t61 = data?.serviceFlags?.includes("IS_LAB") && <><div className="text-slate-650 dark:text-slate-350"><span className="text-slate-850 font-bold dark:text-slate-200">Lab:</span>{" "}Included</div><div /> </>;
    $[101] = data.serviceFlags;
    $[102] = t61;
  } else {
    t61 = $[102];
  }
  let t62;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <div className="text-slate-650 dark:text-slate-350"><span className="text-slate-850 font-bold dark:text-slate-200">Certificate:</span>{" "}Course Completion</div>;
    $[103] = t62;
  } else {
    t62 = $[103];
  }
  let t63;
  if ($[104] !== data.serviceFlags) {
    t63 = data?.serviceFlags?.includes("HAS_MEMBERSHIP");
    $[104] = data.serviceFlags;
    $[105] = t63;
  } else {
    t63 = $[105];
  }
  const t64 = t63 as boolean;
  let t65;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <div />;
    $[106] = t65;
  } else {
    t65 = $[106];
  }
  let t66;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <div className="text-slate-650 dark:text-slate-350"><span className="text-slate-850 font-bold dark:text-slate-200">Membership:</span>{" "}Yes</div>;
    $[107] = t66;
  } else {
    t66 = $[107];
  }
  let t67;
  if ($[108] !== t64) {
    t67 = <RenderIf condition={t64}>{t65} {t66}</RenderIf>;
    $[108] = t64;
    $[109] = t67;
  } else {
    t67 = $[109];
  }
  const t68 = data.offers.length > 0;
  let t69;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = <Sparkles className="size-5 shrink-0 text-orange-600 dark:text-orange-400" />;
    $[110] = t69;
  } else {
    t69 = $[110];
  }
  let t70;
  if ($[111] !== data.offers.length) {
    t70 = <PopoverTrigger nativeButton={false} render={<div className="text-slate-650 dark:text-slate-350 w-max"><span className="text-slate-850 font-bold dark:text-slate-200">{data.offers.length}</span>{" "}Special Offers Available!</div>} />;
    $[111] = data.offers.length;
    $[112] = t70;
  } else {
    t70 = $[112];
  }
  let t71;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = <PopoverTitle>Offers</PopoverTitle>;
    $[113] = t71;
  } else {
    t71 = $[113];
  }
  let t72;
  if ($[114] !== data.offers) {
    t72 = data.offers.map(_temp);
    $[114] = data.offers;
    $[115] = t72;
  } else {
    t72 = $[115];
  }
  let t73;
  if ($[116] !== t72) {
    t73 = <PopoverDescription>{t72}</PopoverDescription>;
    $[116] = t72;
    $[117] = t73;
  } else {
    t73 = $[117];
  }
  let t74;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <div className="text-muted-foreground mt-3 text-xs italic">{"Available on summary page after clicking on \"Enroll Now\" button."}</div>;
    $[118] = t74;
  } else {
    t74 = $[118];
  }
  let t75;
  if ($[119] !== t73) {
    t75 = <PopoverContent align="start"><PopoverHeader>{t71}{t73}{t74}</PopoverHeader></PopoverContent>;
    $[119] = t73;
    $[120] = t75;
  } else {
    t75 = $[120];
  }
  let t76;
  if ($[121] !== t70 || $[122] !== t75) {
    t76 = <Popover>{t70}{t75}</Popover>;
    $[121] = t70;
    $[122] = t75;
    $[123] = t76;
  } else {
    t76 = $[123];
  }
  let t77;
  if ($[124] !== t68 || $[125] !== t76) {
    t77 = <RenderIf condition={t68}>{t69}{t76}</RenderIf>;
    $[124] = t68;
    $[125] = t76;
    $[126] = t77;
  } else {
    t77 = $[126];
  }
  let t78;
  if ($[127] !== t47 || $[128] !== t48 || $[129] !== t53 || $[130] !== t59 || $[131] !== t61 || $[132] !== t67 || $[133] !== t77) {
    t78 = <div className="flex flex-1 flex-col justify-center"><div className="grid grid-cols-[20px_1fr] items-center gap-x-3 gap-y-3 text-sm">{t47}{t48}{t49}{t50}{t53}{t54}{t55}{t56} {t59}{t60} {t61}{t62}{t67}{t77}</div></div>;
    $[127] = t47;
    $[128] = t48;
    $[129] = t53;
    $[130] = t59;
    $[131] = t61;
    $[132] = t67;
    $[133] = t77;
    $[134] = t78;
  } else {
    t78 = $[134];
  }
  const t79 = !isHiddenPrice;
  let t80;
  if ($[135] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = <ParticipantSelector min={1} onChange={setQuantity} />;
    $[135] = t80;
  } else {
    t80 = $[135];
  }
  const t81 = data.eventDetail.price * quantity;
  let t82;
  if ($[136] !== data.eventDetail.currency || $[137] !== t81) {
    t82 = formatCurrency(t81, data.eventDetail.currency);
    $[136] = data.eventDetail.currency;
    $[137] = t81;
    $[138] = t82;
  } else {
    t82 = $[138];
  }
  let t83;
  if ($[139] !== t82) {
    t83 = <div className="text-primary text-2xl font-extrabold tracking-tight transition-all duration-300 sm:text-3xl dark:text-blue-400">{t82}</div>;
    $[139] = t82;
    $[140] = t83;
  } else {
    t83 = $[140];
  }
  const t84 = data.eventDetail.discountValue > 0;
  const t85 = !isCampaignOffer;
  let t86;
  if ($[141] !== isCampaignOffer || $[142] !== t85) {
    t86 = clsx("mr-2 text-sm line-through", {
      "text-gray-500": t85,
      "font-semibold text-orange-500": isCampaignOffer
    });
    $[141] = isCampaignOffer;
    $[142] = t85;
    $[143] = t86;
  } else {
    t86 = $[143];
  }
  const t87 = (data.eventDetail.price + data.eventDetail.discountValue) * quantity;
  let t88;
  if ($[144] !== data.eventDetail.currency || $[145] !== t87) {
    t88 = formatCurrency(t87, data.eventDetail.currency);
    $[144] = data.eventDetail.currency;
    $[145] = t87;
    $[146] = t88;
  } else {
    t88 = $[146];
  }
  let t89;
  if ($[147] !== t86 || $[148] !== t88) {
    t89 = <span className={t86}>{t88}</span>;
    $[147] = t86;
    $[148] = t88;
    $[149] = t89;
  } else {
    t89 = $[149];
  }
  let t90;
  if ($[150] !== t84 || $[151] !== t89) {
    t90 = <RenderIf condition={t84}>{t89}</RenderIf>;
    $[150] = t84;
    $[151] = t89;
    $[152] = t90;
  } else {
    t90 = $[152];
  }
  const t91 = data.eventDetail.discountValue > 0;
  const t92 = !isCampaignOffer;
  let t93;
  if ($[153] !== isCampaignOffer || $[154] !== t92) {
    t93 = clsx("text-sm font-medium", {
      "text-green-700": t92,
      "font-bold text-orange-800": isCampaignOffer
    });
    $[153] = isCampaignOffer;
    $[154] = t92;
    $[155] = t93;
  } else {
    t93 = $[155];
  }
  const t94 = data.eventDetail.discountPercentNumber;
  const t95 = data.eventDetail.offerDiscountType === "Percentage" ? "%" : data.eventDetail.currency;
  const t96 = data.eventDetail.discountValue * quantity;
  let t97;
  if ($[156] !== data.eventDetail.currency || $[157] !== t96) {
    t97 = formatCurrency(t96, data.eventDetail.currency);
    $[156] = data.eventDetail.currency;
    $[157] = t96;
    $[158] = t97;
  } else {
    t97 = $[158];
  }
  let t98;
  if ($[159] !== data.eventDetail.discountPercentNumber || $[160] !== t93 || $[161] !== t95 || $[162] !== t97) {
    t98 = <span className={t93}>Save {t94}{" "}{t95}{" "}({t97})</span>;
    $[159] = data.eventDetail.discountPercentNumber;
    $[160] = t93;
    $[161] = t95;
    $[162] = t97;
    $[163] = t98;
  } else {
    t98 = $[163];
  }
  let t99;
  if ($[164] !== t91 || $[165] !== t98) {
    t99 = <RenderIf condition={t91}>{t98}</RenderIf>;
    $[164] = t91;
    $[165] = t98;
    $[166] = t99;
  } else {
    t99 = $[166];
  }
  let t100;
  if ($[167] !== data.eventDetail.currency || $[168] !== data.eventDetail.price || $[169] !== quantity) {
    t100 = quantity > 1 && <div className="text-slate-550 text-xs font-medium">{formatCurrency(data.eventDetail.price, data.eventDetail.currency)} per pax</div>;
    $[167] = data.eventDetail.currency;
    $[168] = data.eventDetail.price;
    $[169] = quantity;
    $[170] = t100;
  } else {
    t100 = $[170];
  }
  let t101;
  if ($[171] !== t100 || $[172] !== t83 || $[173] !== t90 || $[174] !== t99) {
    t101 = <div className="space-y-1">{t83}{t90}{t99}{t100}</div>;
    $[171] = t100;
    $[172] = t83;
    $[173] = t90;
    $[174] = t99;
    $[175] = t101;
  } else {
    t101 = $[175];
  }
  let t102;
  if ($[176] !== t101 || $[177] !== t79) {
    t102 = <RenderIf condition={t79}>{t80}{t101}</RenderIf>;
    $[176] = t101;
    $[177] = t79;
    $[178] = t102;
  } else {
    t102 = $[178];
  }
  const t103 = !isHiddenPrice;
  let t104;
  if ($[179] !== data.serviceId || $[180] !== openPopup) {
    t104 = <Button className="w-full sm:w-55" onClick={() => openPopup({
      type: "enquiry",
      title: "Enquire About Course & Pricing",
      description: "Get detailed information about course pricing, upcoming batch dates, and training schedules.",
      data: {
        serviceId: data.serviceId,
        submitLabel: "Enquire Now"
      }
    })}>Enquire Now</Button>;
    $[179] = data.serviceId;
    $[180] = openPopup;
    $[181] = t104;
  } else {
    t104 = $[181];
  }
  let t105;
  if ($[182] !== data || $[183] !== isCampaignOffer || $[184] !== quantity) {
    t105 = <EnrollNowDialog isCampaignOffer={isCampaignOffer} participant={quantity} course={data.serviceName} date={data.formattedDate} data={data} />;
    $[182] = data;
    $[183] = isCampaignOffer;
    $[184] = quantity;
    $[185] = t105;
  } else {
    t105 = $[185];
  }
  let t106;
  if ($[186] !== t103 || $[187] !== t104 || $[188] !== t105) {
    t106 = <RenderIf condition={t103} fallback={t104}>{t105}</RenderIf>;
    $[186] = t103;
    $[187] = t104;
    $[188] = t105;
    $[189] = t106;
  } else {
    t106 = $[189];
  }
  let t107;
  if ($[190] === Symbol.for("react.memo_cache_sentinel")) {
    t107 = <Button type="button" variant="outline" size="sm" nativeButton={false} className="border-primary text-primary w-full rounded-full sm:w-55" render={<Link href="#queries" onClick={handleScroll} />}>Request For Group Training</Button>;
    $[190] = t107;
  } else {
    t107 = $[190];
  }
  let t108;
  if ($[191] === Symbol.for("react.memo_cache_sentinel")) {
    t108 = <FillingFast />;
    $[191] = t108;
  } else {
    t108 = $[191];
  }
  let t109;
  if ($[192] !== data.isFastFilling) {
    t109 = <RenderIf condition={data.isFastFilling}>{t108}</RenderIf>;
    $[192] = data.isFastFilling;
    $[193] = t109;
  } else {
    t109 = $[193];
  }
  let t110;
  if ($[194] !== t106 || $[195] !== t109) {
    t110 = <div className="flex w-full flex-col gap-2 sm:items-end">{t106}{t107}{t109}</div>;
    $[194] = t106;
    $[195] = t109;
    $[196] = t110;
  } else {
    t110 = $[196];
  }
  let t111;
  if ($[197] !== t102 || $[198] !== t110) {
    t111 = <div className="flex h-full min-w-60 flex-col justify-end gap-6 sm:items-end sm:text-right">{t102}{t110}</div>;
    $[197] = t102;
    $[198] = t110;
    $[199] = t111;
  } else {
    t111 = $[199];
  }
  let t112;
  if ($[200] !== t111 || $[201] !== t78) {
    t112 = <div className="bg-card flex flex-col justify-between gap-6 p-6 md:col-span-7 md:flex-row">{t78}{t111}</div>;
    $[200] = t111;
    $[201] = t78;
    $[202] = t112;
  } else {
    t112 = $[202];
  }
  let t113;
  if ($[203] !== t112 || $[204] !== t46) {
    t113 = <div className="grid grid-cols-1 md:grid-cols-10">{t46}{t112}</div>;
    $[203] = t112;
    $[204] = t46;
    $[205] = t113;
  } else {
    t113 = $[205];
  }
  let t114;
  if ($[206] !== t113 || $[207] !== t7) {
    t114 = <Card className="relative overflow-hidden p-0">{t7}{t113}</Card>;
    $[206] = t113;
    $[207] = t7;
    $[208] = t114;
  } else {
    t114 = $[208];
  }
  let t115;
  if ($[209] !== t114 || $[210] !== t3) {
    t115 = <div className="relative">{t3}{t114}</div>;
    $[209] = t114;
    $[210] = t3;
    $[211] = t115;
  } else {
    t115 = $[211];
  }
  return t115;
};
function _temp(offer) {
  return <Text key={offer.id} render={<span />} className="text-xs">{offer.description}</Text>;
}